import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Car Service
 * Handles all car-related API calls (Brands, Models, Types, Fuel Types)
 */
const carService = {
  // Car Brands
  getAllCarBrands: async () => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.BRAND.GET_ALL);
    return response.data;
  },

  addCarBrand: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.BRAND.ADD, data);
    return response.data;
  },

  updateCarBrand: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.BRAND.UPDATE, data);
    return response.data;
  },

  deleteCarBrand: async (carBrandId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.BRAND.DELETE, { carBrandId });
    return response.data;
  },

  // Car Models
  getAllCarModels: async () => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.GET_ALL);
    return response.data;
  },

  getCarModelsByBrand: async (carBrandId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.GET_BY_BRAND, { carBrandId });
    return response.data;
  },

  addCarModel: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.ADD, data);
    return response.data;
  },

  updateCarModel: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.UPDATE, data);
    return response.data;
  },

  deleteCarModel: async (carModelId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.DELETE, { carModelId });
    return response.data;
  },

  updateCarModelImage: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL.UPDATE_IMAGE, data);
    return response.data;
  },

  // Car Model Fuel
  getAllCarModelFuel: async () => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL_FUEL.GET_ALL);
    return response.data;
  },

  addCarModelFuel: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL_FUEL.ADD, data);
    return response.data;
  },

  getFuelTypesByCarModelId: async (carModelId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.MODEL_FUEL.GET_FUEL_BY_MODEL, {
      carModelId,
    });
    return response.data;
  },

  // Car Types
  getAllCarTypes: async () => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.TYPE.GET_ALL);
    return response.data;
  },

  addCarType: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.TYPE.ADD, data);
    return response.data;
  },

  updateCarType: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.TYPE.UPDATE, data);
    return response.data;
  },

  deleteCarType: async (carTypeId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.TYPE.DELETE, { carTypeId });
    return response.data;
  },

  // Fuel Types
  getAllFuelTypes: async () => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.FUEL_TYPE.GET_ALL);
    return response.data;
  },

  addFuelType: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.FUEL_TYPE.ADD, data);
    return response.data;
  },

  updateFuelType: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.FUEL_TYPE.UPDATE, data);
    return response.data;
  },

  deleteFuelType: async (fuelTypeId) => {
    const response = await apiClient.post(API_ENDPOINTS.CAR.FUEL_TYPE.DELETE, { fuelTypeId });
    return response.data;
  },
};

export default carService;

